$(function(){

    $('[data-booking-menu-trigger]').on('click',function(e){
        // init
        e.preventDefault();
        let $toggle = $(this);
        let $list_container = $('.booking-list');
        let toggle_active_class = 'is-opened';
        let visible_class = 'booking-list--visible';
        if ($list_container.hasClass(visible_class)) {
            $list_container.removeClass(visible_class);
            $toggle.removeClass(toggle_active_class);
        }else {
            $list_container.addClass(visible_class);
            $toggle.addClass(toggle_active_class);
        }
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/booking-menu.js